var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commonPopup',{attrs:{"header":"服务说明","footer":"我知道了"},on:{"footerClick":_vm.footerClick}},[_c('div',{staticClass:"ctn"},_vm._l((_vm.serviceList),function(item,index){return _c('div',{key:index},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_c('p',[_vm._v(_vm._s(item.desc))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }